var ajaxCalls = require('./ajaxCalls');

var finish = function(exam,global) { // here

    // update the answer
    var answer = global.response.answers[global.questionIndex];
    ajaxCalls.scoreQuiz(global.userId,global.quizId,answer);

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {

        $(modalDiv).find('.modal-content').html('');
        document.location.href = sprintf(global.examReviewLink,{ quizId:global.quizId, userId:global.userId});
    });
    // Give some time for the server to score the exam [JayG]2023-08-04
    var modalcontentstr = '<div class="modal-header">Finish</div><div class="modal-body">' +
        'Please wait. Scoring...';

    modalcontentstr += '</div><div class="modal-footer"><button type="button" class="btn btn-default" ' +
        'data-dismiss="modal" style="display: none">Review Quiz</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalDiv).find('.modal-content').append(modalContent);

    var seconds = global.response.answers.length / 100;
    var wait = Math.ceil(seconds) * 1000;
    setTimeout(function () {
        $(modalDiv).find('.modal-body').html('Your quiz has been scored. Click review to see your score.');
        $(modalDiv).find('.modal-footer > button').show();
    }, wait);
    $(modalDiv).modal();

}

module.exports = finish;


//////////////////
// WEBPACK FOOTER
// ./src/quiz_finish.js
// module id = 327
// module chunks = 0